import { HTMLAttributes } from 'react';

import { LinkBreak1Icon } from '@radix-ui/react-icons';
import { useEditorState, type Editor } from '@tiptap/react';

import { Button } from '../../../primitives/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../primitives/tooltip';

interface ButtonUnlinkProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  editor: Editor;
}

export function ButtonUnlink({ className, editor }: ButtonUnlinkProps) {
  const { isLink } = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      isLink: editor.isActive('link'),
    }),
  });

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <Button
            aria-label="Quitar enlace"
            className={className}
            disabled={!isLink}
            size="icon"
            variant="ghost"
            onClick={() => editor.chain().focus().unsetLink().run()}
          >
            <LinkBreak1Icon className="size-4" />
          </Button>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="flex flex-col">Quitar enlace</p>
      </TooltipContent>
    </Tooltip>
  );
}
